import React, {useEffect, useState} from 'react';
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ProfilePath from "../../sections/profileSection/components/ProfilePath";
import ContactSectionComponent from "../main/sections/contactSection/ContactSectionComponent";
import MyCodesOrderCategory from "./components/MyCodesOrderCategory";
import {useParams} from "react-router-dom";
import "./codesPage.scss";
import CurrentOrderCodesList from "./components/CurrentOrderCodesList";
import PurchaseHistoryOrderCodesList from "./components/PurchaseHistoryOrderCodesList";
import {
  UseGetAllDineInReservationsByUserId,
  UseGetAllTakeOutReservationsByUserId,
  UseGetReservationsByUserId
} from "../../api/useReservation";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../reducers/store";
import {setUserValue} from "../../reducers/userReducer";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
      return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + " " + restOfWords;
    }
}

const CodesPage = () => {
    const { category } = useParams();
    const dispatch = useDispatch();
    const userIdStore = useSelector((state: RootState) => state.user.id);
    const [userCategories, setUserCategories] = useState<string[]>([]);
    const [selectedCategory, setSelectedCategory] = useState<string>(category ? getCategoryName(category) : "Current");
    const [selectedPurchaseHistoryCategory, setSelectedPurchaseHistoryCategory] = useState<string>("All");
    const [currentOrders, setCurrentOrders] = useState<any>([]);
    const [purchaseHistoryOrders, setPurchaseHistoryOrders] = useState<any>([]);

    const selectCategory = (category: string) => {
        setSelectedCategory(category);
    }

    const selectPurchaseHistoryCategory = (category: string) => {
        setSelectedPurchaseHistoryCategory(category);
    }

    /*useEffect(() => {
        try {
          setUserCategories([
            'Current',
            'Purchase history'
          ]);
            const fetchData = async () => {
              if (userIdStore) {
                UseGetAllDineInReservationsByUserId(userIdStore).then((response: any) => {
                  console.log("UseGetAllDineInReservationsByUserId response: ", response);
                  if (response.status === 200) {
                    if (response.result && response.result.length > 0) {
                      dispatch(setUserValue({ key: "qrCodeCount", value: response.result.filter((order: any) => order && order.expireStatus && order.expireStatus.toLowerCase() !== "expired").length }));
                      setCurrentOrders(response.result.filter((order: any) => order && order.expireStatus && order.expireStatus.toLowerCase() !== "expired"))
                    }
                  }
                });

                UseGetAllTakeOutReservationsByUserId(userIdStore).then((response: any) => {

                });
              }
            }
            fetchData().then();
        } catch (error) {
            console.log(error);
        }
    }, [userIdStore]);*/

  useEffect(() => {
    try {
      setUserCategories([
        'Current',
        'Purchase history'
      ]);

      const fetchData = async () => {
        if (userIdStore) {
          
          UseGetReservationsByUserId(userIdStore).then((response) => {
            console.log("response: ", response);
            let currentOrders = [];
            let historyOrders = [];
            let qrCodeCount = 0;
            if (response && response.status === 200 && response.result) {
              if (response.result.length > 0) {
                currentOrders = response.result.filter((order: any) => order && !order.isDeclined);
                qrCodeCount = qrCodeCount + currentOrders.length;
                setCurrentOrders(response.result);
                historyOrders = response.result.filter((order: any) => order && order.isConfirmed && order.isReserved && order.isPaid && !order.isDeclined);
                setPurchaseHistoryOrders(historyOrders);
                dispatch(setUserValue({ key: "qrCodeCount", value: qrCodeCount }));
              } else {
                setCurrentOrders([]);
              }
            } else {
              setCurrentOrders([]);
            }
          })
        }
      }
      fetchData().then();
    } catch (error) {
      console.log(error);
    }
  }, [userIdStore]);


  useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  
  return (
      <div className="codesPage__container">
          <div className="mainSectionComponent__container-content-overlay"></div>
          <OrderHeadSectionComponent />
          <ProfilePath
              path={['My codes', selectedCategory ? getCategoryName(selectedCategory) : ""]}
              component="My codes"
          />
  
          <MyCodesOrderCategory
              orderCategories={userCategories ? userCategories : []}
              selectedCategoryProps={getCategoryName(selectedCategory)}
              handleSelectCategory={selectCategory}
          />
  
        {
          selectedCategory === "Current" && currentOrders && currentOrders.length > 0 && (
            <div className="codesPage__container_content">
                <CurrentOrderCodesList userOrderData={currentOrders}/>
            </div>
          )
        }
        {
          selectedCategory === "Purchase history" && purchaseHistoryOrders && purchaseHistoryOrders.length > 0 && (
            <div className="codesPage__container_content">
                <PurchaseHistoryOrderCodesList
                  userOrderData={purchaseHistoryOrders}
                  handleSelectCategory={selectPurchaseHistoryCategory}
                  selectedCategoryProps={getCategoryName(selectedPurchaseHistoryCategory)}
                />
            </div>
          )
        }
          <ContactSectionComponent />
      </div>
  );
};

export default CodesPage;